// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__pJMa_","content":"LoadingAlert_content__w-cgg"};